<template>
  <!-- <ValidationProvider tag="div" :rules="rules" :label="label" :vid="vid" v-slot="{ errors }"> -->
  <!-- {{currItems}} -->
  <div class="row">
    <div
      v-for="(items, index) in currItems"
      :key="'Currency' + index"
      class="col-sm-12 col-md-12 mt-10px"
    >
      
        <div class="input-group  flex-flow-row d-flex wrapper-prepend">
          <div class="input-group-prepend">
            <div></div>

            <span class="input-group-text">{{
              getCurrencyLabel(items)

            }}</span>
          </div>
         <div class ="currency_field" v-for="(item,index) of items" :key="'i'+index" >
           <!-- {{index}} -->
           <div class="w-100">
           <div v-if="index=='value'" >
            <!-- <div v-if="Object.keys(items)=='value'"> -->
              <ValidationProvider
        tag="div"
        :name="name"
        :rules="rules+'|validDecimal'"
        :label="label"
        :vid="vid"
        v-slot="{ errors }"
      >

          <input  @blur="isPercentage?formatPercentage(items):formatCurrency(items)" @click="isPercentage?formatPercentage(items):onRemoveCurrFormat('value',items)"            type="text"
            class="form-control"
            v-model=" items.value"

            :placeholder="placeholder"
            :maxlength="isPercentage?5:getMaxCharacters(items.value)"
            @input="onInput"
          />
            <div  v-if="errors && errors[0]" class="invalid-feedback icon">
          <span>{{ errors[0] }}</span>
        </div>
            </ValidationProvider>
          </div>
          <div v-else-if="index=='postpaidlimit'">
             <!-- <div v-else-if="Object.keys(items)=='postpaidlimit'"> -->
               <ValidationProvider
        tag="div"
        :rules="rules+'|validDecimal'"
        :label="label"
        :vid="vid"
        v-slot="{ errors }"
      >
          <input  @blur="isPercentage?formatPercentage(items):formatCurrency(items)" @click="isPercentage?formatPercentage(items):onRemoveCurrFormat('postpaidlimit',items)"
            type="text"

            class="form-control"
            v-model=" items.postpaidlimit"

            :placeholder="placeholder"
            :maxlength="isPercentage?5:getMaxCharacters(items.postpaidlimit)"
             @input="onInput"
          />
              <div  v-if="errors && errors[0]" class="invalid-feedback icon">
          <span>{{ errors[0] }}</span>
        </div>

                 </ValidationProvider>
          </div>

          
           <div v-else-if="index=='amount'" >
              <!-- <div v-else-if="Object.keys(items)=='amount'"> -->

                 <ValidationProvider
        tag="div"
        :rules="rules+'|validDecimal'"
        :label="label"
        :vid="vid"
        v-slot="{ errors }"
      >
          <input @blur="isPercentage?formatPercentage(items):formatCurrency(items)"  @click="isPercentage?formatPercentage(items):onRemoveCurrFormat('amount',items)"
            type="text"
            class="form-control"
            v-model=" items.amount"

            :placeholder="placeholder"
            :maxlength="isPercentage?5:getMaxCharacters(items.amount)"
             @input="onInput"
          />
           <div  v-if=" errors && errors[0]" class="invalid-feedback icon">
          <span>{{ errors[0] }}</span>
        </div>

                 </ValidationProvider>
          </div>
         </div>
          </div>

         <div v-if="isPercentage" class="input-group-append">
           <span class="input-group-text">{{ " % " }}</span>
         </div>
        </div>

    
      <!-- {{items.amount }} -->
        <!-- <br /> -->
    </div>
  </div>
</template>
<script>
import {getMaxCharOfAmount,removeCurrFormat} from './../../util/util'

import { ValidationProvider,localize } from "vee-validate";
import {PATHNAME,COMPONENT_NAME} from './../../util/constants'
// import nb from "./../../translations/validation/nb.json";
// import en from "./../../translations/validation/en.json";
import Logger from "./../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "./../../config/API_DATA";
import BaseConfiguration from "./../../config/base";

// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: "cCurrencyBoxes",

  components: {
    ValidationProvider
  },
  model: {
    prop: "selValue"
  },
  props: {
    selValue: {
      type: Object | Array,
      default: null
    },
    currItems: {
      type: Array | Object,
      default: null
    },
    value: {
      type: String,
      default: ""
    },
    rules: {
      type: [String, Object],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    vid: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    selValue: {
      type: Object | Array,
      default: null
    },
    isPercentage: {
      type: Boolean,
      default: false
    },
   
  },
  data: () => ({
    currentValue: null,
    isUpdatedFirst:false,
  }),

  methods: {
     onInput(){
  this.$emit("onInput"); 
    },
         ///if amount field to get max characters
     getMaxCharacters(pAmount) {
        try {
          if(BaseConfiguration.isDebug) console.log("getMaxCharacters");
          let retValue;
        if(pAmount){
    if(pAmount.toString().includes('.')){
     let indexOfDot=pAmount.toString().indexOf(".");
     if(indexOfDot==14){
        retValue= 17;

     } else if(indexOfDot==13){
           retValue= 16;
     }
     else{
            retValue=15;
     }
 }  else{
     retValue=15;
 }
        }
        
        return retValue;
        }
    
         catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.SYSTEM_TOPUP,
                  "error in getMaxCharacters",
                  err.toString(),
                  "getMaxCharacters",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    onRemoveCurrFormat(pValue,pItem) {
        try {
          if(BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");
          this.isUpdatedFirst=true;
         for (let index = 0; index < this.currItems.length; index++) {
                 const curr = this.currItems[index];
              
               for (let index = 0; index < Object.keys(curr).length; index++) {
                 const currObj = Object.keys(curr)[index];
                if(pItem.hasOwnProperty('currency'))
                {
                  if(currObj=='value'&&pValue=="value"&&pItem.currency==curr.currency){
                     curr.value= removeCurrFormat( curr.value);
                  }
                  if(currObj=='amount'&&pValue=="amount"&&pItem.currency==curr.currency){
                    curr.amount= removeCurrFormat( curr.amount);
                  }
                   if(currObj=='postpaidlimit'&&pValue=="postpaidlimit"&&pItem.currency==curr.currency){
                     curr.postpaidlimit= removeCurrFormat( curr.postpaidlimit);
                  }
                }else if(pItem.hasOwnProperty('code')){
                  if(currObj=='value'&&pValue=="value"&&pItem.code==curr.code){
                     curr.value= removeCurrFormat( curr.value);
                  }
                  if(currObj=='amount'&&pValue=="amount"&&pItem.code==curr.code){
                    curr.amount= removeCurrFormat( curr.amount);
                  }
                   if(currObj=='postpaidlimit'&&pValue=="postpaidlimit"&&pItem.code==curr.code){
                     curr.postpaidlimit= removeCurrFormat( curr.postpaidlimit);
                  }

                }else if(pItem.hasOwnProperty('currency_code')){
                    if(currObj=='value'&&pValue=="value"&&pItem.currency_code.code==curr.currency_code.code){
                     curr.value= removeCurrFormat( curr.value);
                  }
                  if(currObj=='amount'&&pValue=="amount"&&pItem.currency_code.code==curr.currency_code.code){
                    curr.amount= removeCurrFormat( curr.amount);
                  }
                   if(currObj=='postpaidlimit'&&pValue=="postpaidlimit"&&pItem.currency_code.code==curr.currency_code.code){
                     curr.postpaidlimit= removeCurrFormat( curr.postpaidlimit);
                  }
                }
                 
                }
              }
        } catch (err) {
                let body = Logger.buildRequest(
                  'cCurrencyBoxes',
                  "error in onRemoveCurrFormat",
                  err.toString(),
                  "onRemoveCurrFormat",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 

        formatPercentage(item) {
      try {
                  if(BaseConfiguration.isDebug) console.log("formatPercentage");

        // if (
        //   item.value.toString().includes(".") &&
        //   item.value.toString().indexOf(".") == item.value.toString().length - 1
        // ) {
         
        // } else 
    

        if (item && item.amount) {
          item.amount =this.remPercentageDeci(item.amount) ;
        } else if (item && item.value) {
          item.value = this.remPercentageDeci(item.value);
        }else if (item && item.postpaidlimit) {
          item.postpaidlimit = this.remPercentageDeci(item.postpaidlimit);
        }

        // this.$emit("change", item);
      } catch (err) {
          let body = Logger.buildRequest(
          'cCurrencyBoxes',
          "error in formatPercentage",
          err.toString(),
          "formatPercentage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    ///to remove decimal if > 100
    remPercentageDeci(pCurrency){
      try{
        if(pCurrency>=100&&pCurrency.toString().includes('.')){
          return 100;
        }else{
          return pCurrency;
        }
       
      }catch (err) {
          let body = Logger.buildRequest(
          'cCurrencyBoxes',
          "error in remPercentageDeci",
          err.toString(),
          "remPercentageDeci",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

    },

           getCurrencyLabel(items) {
              let retValue="";
               try {
                 if(BaseConfiguration.isDebug) console.log("getCurrencyLabel");
      retValue= items.currency_code && items.currency_code.code
                ? items.currency_code.code
                : items.currencycode && items.currencycode.code
                ? items.currencycode.code
                : items.code
                ? items.code
                : items.currency


                if(typeof retValue!='string')
                      {
                        retValue=''
                      }
               
                
           
               } catch (err) {
                       let body = Logger.buildRequest(
                         'cCurrencyBoxes',
                         "error in getCurrencyLabel",
                         err.toString(),
                         "getCurrencyLabel",
                         LOG_TYPE.ERROR
                       );
                       Logger.getResponse(body);
                     }
                 return retValue;
               }, 



        /*    */

    getMaxChars(pCurrency) {
        try {
          if(BaseConfiguration.isDebug) console.log("getMaxChars");
  
    
    let retValue=getMaxCharOfAmount(pCurrency);

    return retValue;
    
    
        } catch (err) {
                let body = Logger.buildRequest(
                  'cCurrencyBoxes',
                  "error in getMaxChars",
                  err.toString(),
                  "getMaxChars",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
    /* onChange({ type, target }) {
       console.log(target.value);
       let newVal = this.$options.filters.formatNumber(target.value);
       console.log(newVal);
       this.$emit("input", newVal);
     }, */

    formatCurrency(item) {
      try {
                  if(BaseConfiguration.isDebug) console.log("formatCurrency");

        // if (
        //   item.value.toString().includes(".") &&
        //   item.value.toString().indexOf(".") == item.value.toString().length - 1
        // ) {
         
        // } else 
    
if(item.hasOwnProperty('currency_code')){
    if (item && item.amount) {
          item.amount = this.$options.filters.currencyFormat(item.amount,item.currency_code.code);
        } else if (item && item.value) {
          item.value = this.$options.filters.currencyFormat(item.value,item.currency_code.code);
        }else if (item && item.postpaidlimit) {
          item.postpaidlimit = this.$options.filters.currencyFormat(item.postpaidlimit,item.currency_code.code);
        }

}else if(item.hasOwnProperty('code')){
     if (item && item.amount) {
          item.amount = this.$options.filters.currencyFormat(item.amount,item.code);
        } else if (item && item.value) {
          item.value = this.$options.filters.currencyFormat(item.value,item.code);
        }else if (item && item.postpaidlimit) {
          item.postpaidlimit = this.$options.filters.currencyFormat(item.postpaidlimit,item.code);
        }
}else if(item.hasOwnProperty('currency')){
     if (item && item.amount) {
          item.amount = this.$options.filters.currencyFormat(item.amount,item.currency);
        } else if (item && item.value) {
          item.value = this.$options.filters.currencyFormat(item.value,item.currency);
        }else if (item && item.postpaidlimit) {
          item.postpaidlimit = this.$options.filters.currencyFormat(item.postpaidlimit,item.currency);
        }

}
        //  this.$emit("change", item);
      } catch (err) {
          let body = Logger.buildRequest(
          'cCurrencyBoxes',
          "error in formatCurrency",
          err.toString(),
          "formatCurrency",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },

  watch: {
    
        currItems(val) {

             try {
    if(!this.isUpdatedFirst&&!this.isPercentage){
               
              for (let index = 0; index < this.currItems.length; index++) {
                 const curr = this.currItems[index];
              
               for (let index = 0; index < Object.keys(curr).length; index++) {
                 const currObj = Object.keys(curr)[index];
        
     if(curr.hasOwnProperty('currency_code')){
               if(currObj=='value'){
                     curr.value= this.$options.filters.currencyFormat( curr.value,curr.currency_code.code);
                  }
                  if(currObj=='amount'){
                    curr.amount= this.$options.filters.currencyFormat( curr.amount,curr.currency_code.code);
                  }
                   if(currObj=='postpaidlimit'){
                     curr.postpaidlimit= this.$options.filters.currencyFormat( curr.postpaidlimit,curr.currency_code.code);
                  }
        }else if(curr.hasOwnProperty('currency')){
             if(currObj=='value'){
                     curr.value= this.$options.filters.currencyFormat( curr.value,curr.currency);
                  }
                  if(currObj=='amount'){
                    curr.amount= this.$options.filters.currencyFormat( curr.amount,curr.currency);
                  }
                   if(currObj=='postpaidlimit'){
                     curr.postpaidlimit= this.$options.filters.currencyFormat( curr.postpaidlimit,curr.currency);
                  }
        }else if(curr.hasOwnProperty('code')){
           if(currObj=='value'){
                     curr.value= this.$options.filters.currencyFormat( curr.value,curr.code);
                  }
                  if(currObj=='amount'){
                    curr.amount= this.$options.filters.currencyFormat( curr.amount,curr.code);
                  }
                   if(currObj=='postpaidlimit'){
                     curr.postpaidlimit= this.$options.filters.currencyFormat( curr.postpaidlimit,curr.code);
                  }
        }
                  
                }
              }
    }
          } catch (err) {
              let body = Logger.buildRequest( 'cCurrencyBoxes', "", err.toString(), "currItems", LOG_TYPE.ERROR);
              Logger.getResponse(body);
          }
      },
  },
  created() {


  }
 
};
</script>
<style>
.currencycode {
  padding-right: 0px;
  margin-top: 20px;
}
.currencytext {
  padding-left: 0px;
}
.invalid-feedback {
  display: block;
}
</style>
